export default  {
	name: '',
	feed_name: '',
	plan_number: '',
	feed_name_secondary: '',
    builder: '',
    files: '',
	blueprints: [],
    sqft: '',
    pdf: '',
    type: '',
    stories: '',
    garage: '',
    half_baths: '',
    full_baths: '',
    beds: '',
	description: '',
	properties:[],
	manual_properties: [],
	base_prices: {},
	lot_types: [],
	arc_review_notes: '',
	classifications: [],
	roof_pitch: '',
	masonry_percent: ''
}